import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/header_bis';
import { actualites } from '../data/actualites';

export default function ActualitesPage() {
  const location = useLocation();
  const [lightbox, setLightbox] = useState(null); // { images: [], index: 0 }

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150);
    } else {
      window.scrollTo(0, 0);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!lightbox) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') setLightbox(null);
      if (e.key === 'ArrowRight') setLightbox(lb => ({ ...lb, index: (lb.index + 1) % lb.images.length }));
      if (e.key === 'ArrowLeft') setLightbox(lb => ({ ...lb, index: (lb.index - 1 + lb.images.length) % lb.images.length }));
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [lightbox]);

  return (
    <>
      <Header alwaysVisible />

      <div style={{ backgroundColor: 'rgb(26, 36, 66)', minHeight: '100vh', paddingTop: '80px' }}>

        {/* En-tête de page */}
        <div style={{ textAlign: 'center', padding: '40px 24px 20px' }}>
          <div style={{ width: '60px', height: '3px', backgroundColor: '#4A9E47', margin: '0 auto 12px' }} />
          <h1 style={{
            color: '#fff', fontFamily: 'Consolas, monospace',
            fontSize: 'clamp(22px, 3vw, 34px)', margin: 0, letterSpacing: '4px', fontWeight: 'bold',
          }}>
            ACTUALITÉS
          </h1>
          <div style={{ width: '60px', height: '3px', backgroundColor: '#4A9E47', margin: '12px auto 0' }} />
        </div>

        {/* Liste des articles */}
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 24px 100px' }}>
          {actualites.map((item, index) => (
            <article
              key={item.id}
              id={`actu-${item.id}`}
              style={{ scrollMarginTop: '100px', marginBottom: index < actualites.length - 1 ? '90px' : 0 }}
            >
              {/* Image principale */}
              {item.images.length > 0 && (
                <div style={{
                  position: 'relative',
                  width: '100%',
                  aspectRatio: '16/9',
                  backgroundColor: '#0e1530',
                  borderRadius: '14px',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '28px',
                  cursor: 'zoom-in',
                }}
                  onClick={() => setLightbox({ images: item.images, index: 0 })}
                >
                  <img
                    src={item.images[0]}
                    alt={item.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                  <span style={{
                    position: 'absolute', top: '16px', left: '16px',
                    backgroundColor: '#4A9E47',
                    color: '#fff', fontSize: '12px', fontWeight: 'bold',
                    fontFamily: 'Consolas, monospace',
                    padding: '4px 14px', borderRadius: '20px', letterSpacing: '0.5px',
                  }}>
                    {item.date}
                  </span>
                </div>
              )}

              {/* Badge date si pas d'image */}
              {item.images.length === 0 && (
                <span style={{
                  display: 'inline-block',
                  backgroundColor: '#4A9E47',
                  color: '#fff', fontSize: '12px', fontWeight: 'bold',
                  fontFamily: 'Consolas, monospace',
                  padding: '4px 14px', borderRadius: '20px', letterSpacing: '0.5px',
                  marginBottom: '20px',
                }}>
                  {item.date}
                </span>
              )}

              {/* Titre */}
              <h2 style={{
                color: '#fff', fontFamily: 'Consolas, monospace',
                fontSize: 'clamp(18px, 2.5vw, 26px)', fontWeight: 'bold',
                margin: '0 0 14px', lineHeight: 1.3,
              }}>
                {item.title}
              </h2>

              {/* Barre verte */}
              <div style={{ width: '56px', height: '3px', backgroundColor: '#4A9E47', marginBottom: '22px' }} />

              {/* Contenu */}
              {(() => {
                let inQuote = false;
                return item.fullContent.split('\n\n').filter(p => p.trim()).map((paragraph, i) => {
                  const hasOpen = paragraph.includes('«');
                  const hasClose = paragraph.includes('»');
                  let isItalic = false;
                  if (inQuote) {
                    isItalic = true;
                    if (hasClose) inQuote = false;
                  } else if (hasOpen) {
                    isItalic = true;
                    if (!hasClose) inQuote = true;
                  }
                  return (
                    <p key={i} style={{
                      color: 'rgba(255,255,255,0.8)',
                      fontFamily: 'Consolas, monospace',
                      fontSize: '15px',
                      lineHeight: '1.9',
                      marginBottom: '16px',
                      fontStyle: isItalic ? 'italic' : 'normal',
                    }}>
                      {paragraph}
                    </p>
                  );
                });
              })()}

              {/* Liens externes */}
              {item.links && item.links.length > 0 && (
                <div style={{ marginTop: '8px', marginBottom: '24px' }}>
                  {item.links.map((link, i) => (
                    <a key={i} href={link.href} target="_blank" rel="noopener noreferrer" style={{
                      display: 'block',
                      color: '#4A9E47',
                      fontFamily: 'Consolas, monospace',
                      fontSize: '13px',
                      marginBottom: '8px',
                      textDecoration: 'underline',
                      lineHeight: 1.5,
                    }}>
                      → {link.label}
                    </a>
                  ))}
                </div>
              )}

              {/* Galerie photos */}
              {item.images.length > 1 && (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
                  gap: '10px',
                  marginTop: '28px',
                }}>
                  {item.images.slice(1).map((img, i) => (
                    <div key={i}
                      onClick={() => setLightbox({ images: item.images, index: i + 1 })}
                      style={{
                        aspectRatio: '4/3',
                        borderRadius: '10px',
                        overflow: 'hidden',
                        backgroundColor: '#0e1530',
                        cursor: 'zoom-in',
                      }}>
                      <img
                        src={img}
                        alt=""
                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                      />
                    </div>
                  ))}
                </div>
              )}

              {/* Séparateur entre articles */}
              {index < actualites.length - 1 && (
                <div style={{
                  marginTop: '80px',
                  height: '1px',
                  background: 'linear-gradient(to right, transparent, rgba(74,158,71,0.5), transparent)',
                }} />
              )}
            </article>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          onClick={() => setLightbox(null)}
          style={{
            position: 'fixed', inset: 0, zIndex: 1000,
            backgroundColor: 'rgba(0,0,0,0.92)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {/* Close */}
          <button
            onClick={() => setLightbox(null)}
            style={{
              position: 'absolute', top: '16px', right: '20px',
              background: 'none', border: 'none', color: '#fff',
              fontSize: '36px', cursor: 'pointer', lineHeight: 1, zIndex: 1001,
            }}
          >×</button>

          {/* Prev */}
          {lightbox.images.length > 1 && (
            <button
              onClick={e => { e.stopPropagation(); setLightbox(lb => ({ ...lb, index: (lb.index - 1 + lb.images.length) % lb.images.length })); }}
              style={{
                position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.12)', border: 'none', color: '#fff',
                fontSize: '28px', width: '48px', height: '48px', borderRadius: '50%',
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1001,
              }}
            >‹</button>
          )}

          {/* Image */}
          <img
            src={lightbox.images[lightbox.index]}
            alt=""
            onClick={e => e.stopPropagation()}
            style={{
              maxWidth: '90vw', maxHeight: '90vh',
              objectFit: 'contain', borderRadius: '8px',
              boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
            }}
          />

          {/* Next */}
          {lightbox.images.length > 1 && (
            <button
              onClick={e => { e.stopPropagation(); setLightbox(lb => ({ ...lb, index: (lb.index + 1) % lb.images.length })); }}
              style={{
                position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)',
                background: 'rgba(255,255,255,0.12)', border: 'none', color: '#fff',
                fontSize: '28px', width: '48px', height: '48px', borderRadius: '50%',
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1001,
              }}
            >›</button>
          )}

          {/* Counter */}
          {lightbox.images.length > 1 && (
            <div style={{
              position: 'absolute', bottom: '20px', left: '50%', transform: 'translateX(-50%)',
              color: 'rgba(255,255,255,0.5)', fontFamily: 'Consolas, monospace', fontSize: '13px',
            }}>
              {lightbox.index + 1} / {lightbox.images.length}
            </div>
          )}
        </div>
      )}
    </>
  );
}
